import { Spin } from 'antd';
import type React from 'react';
import { useEffect } from 'react';
import { Layout } from 'src/components/layout/layout';
import { useIsUserChecked, useUserActions } from 'src/hooks/data/users';

import { Router } from './router';

import './app.css';

export const App: React.FC = () => {
  const isUserChecked = useIsUserChecked();
  const { getUser } = useUserActions();

  useEffect(() => {
    if (!isUserChecked) {
      getUser();
    }
  }, [isUserChecked, getUser]);

  if (!isUserChecked) {
    return (
      <div className="h-screen flex items-center justify-center">
        <Spin />
      </div>
    );
  }

  return (
    <Layout>
      <Router />
    </Layout>
  );
};
